import React from 'react'
import { FaFacebookSquare } from 'react-icons/fa'
import { FaSquareInstagram } from 'react-icons/fa6'
import { FaYoutube } from 'react-icons/fa'
import { MdOutlineEmail } from 'react-icons/md'
import { MdOutlineHome } from 'react-icons/md'
import { FiPhone } from 'react-icons/fi'
import './HomeContact.css'

const HomeContact = () => {
return (
    <div className="home-contact">
    <div className="icon-container">
        <img
        className="bottom-logo"
        src="https://s3.amazonaws.com/tangledlead.com/images/Tangled+Lead.jpg"
        alt="Company Logo"
        />
        <div className="address-container">
        <MdOutlineHome className="icon home" />
        <span className="address">Lavon, TX 75166</span>
        </div>
        <div className="email">
        <MdOutlineEmail className="icon" />
        <span className="address">dalton.tlw@yahoo.com</span>
        </div>
        <div className="phone-container-bottom">
        <FiPhone className="icon" />
        <span className="address">(469) 338-8263</span>
        </div>
        <div className="contact-icons">
        <a href="https://www.facebook.com/TangledLeadWelding" target="_blank">
            <FaFacebookSquare className="icon" />
        </a>
        <FaSquareInstagram className="icon" />
        <FaYoutube className="icon" />
        </div>
        </div>
    </div>
)
}

export default HomeContact

